import { observer } from 'mobx-react-lite'
import { Divider } from 'shared/ui'
import { EnrolmentStep } from 'widgets/ContactEnrollment'
import { EnrollByWebhook } from 'widgets/EnrollByWebhook/EnrollByWebhook.tsx'
import { CampaignErrorField } from 'pages/campaigns/ui/CampaignView/store/type'
import { type CampaignEnrollContactsStore } from './store/campaignEnrollContactsStore'

type ICampaignEnrollContactsProps = {
  store: CampaignEnrollContactsStore
}

export const CampaignEnrollContacts = observer(({ store }: ICampaignEnrollContactsProps) => {
  const {
    editEnrollment,
    enrollmentStore: { isContactReEnroll, isShowContactsAlert, setIsShowContactsAlert },
    loading,
    error,
    setError,
    enrollmentFilters,
    handleReEnroll,
    enrollByWebhookStore,
  } = store

  const handleClick = () => {
    if (loading) return
    setError('')
    editEnrollment()
  }

  return (
    <div data-error={error && CampaignErrorField.enrollContacts}>
      <EnrolmentStep
        onClick={handleClick}
        error={error}
        enrollmentFilters={enrollmentFilters}
        errorPlacement={'right'}
        tooltipLabel={[
          'Select the conditions to enroll contacts',
          <br key={'br'} />,
          'in your campaign',
        ]}
        contactReEnroll={{
          value: isContactReEnroll,
          onChange: handleReEnroll,
          isShowAlert: isShowContactsAlert,
          onCloseAlert: () => setIsShowContactsAlert(false),
        }}
        bottomContent={
          <>
            <Divider />
            <EnrollByWebhook store={enrollByWebhookStore} source={'campaign'} />
          </>
        }
      />
    </div>
  )
})
